var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadLockIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.703 13.453h-1.406v-3c0-2.906-2.39-5.297-5.297-5.297-2.906 0-5.297 2.39-5.297 5.297v3H8.297v-3c0-3.703 3-6.703 6.703-6.703 3.703 0 6.703 3 6.703 6.703v3z",
    fill: "#879494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26.203H9c-1.219 0-2.25-1.031-2.25-2.25v-9c0-1.219 1.031-2.25 2.25-2.25h12c1.219 0 2.25 1.031 2.25 2.25v9a2.25 2.25 0 01-2.25 2.25zm-12-12a.74.74 0 00-.75.75v9c0 .422.328.75.75.75h12a.74.74 0 00.75-.75v-9a.74.74 0 00-.75-.75H9z",
    fill: "#879494"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.203c0 .844-.656 1.5-1.5 1.5a1.48 1.48 0 01-1.5-1.5c0-.844.656-1.5 1.5-1.5s1.5.703 1.5 1.5z",
    fill: "#879494"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 17.203h-.75l-.75 4.5h2.25l-.75-4.5z",
    fill: "#879494"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadLockIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/padLockIcon.2764dcd0.svg";
export { MemoForwardRef as ReactComponent };